import { connect } from 'react-redux';
import { compose, withStateHandlers } from 'recompose';
import ExpandablePanel from './ExpandablePanel';


export default compose(
  connect(null, {}),

  withStateHandlers(
    { expanded: false },
    { expandPanel: ({ expanded }) => () => ({ expanded: !expanded }) },
  ),
)(ExpandablePanel);
